

import LandingPage from "@/views/LandingPage.vue"
import AboutPage from "@/views/about-nolido.vue"
import AboutNBusinessPage from "@/views/about-nbusiness.vue"
import AboutNLitePage from "@/views/about-nlite.vue"
import AboutNConsultingPage from "@/views/about-nconsulting.vue"
import TermsPage from "@/views/terms.vue"
import PrivacyPage from "@/views/privacy.vue"
import LegalPage from "@/views/legal.vue"
import NmtPage from "@/views/nmt.vue"
import FaqPage from "@/views/faq.vue"
import ContactPage from "@/views/contact.vue"
import DevisPage from "@/views/devis.vue"


export const routes = [
  // Route principale
  {
    path: "/",
    name: "LandingPage",
    component: LandingPage,
    meta: { requiresAuth: false, layout: 'landing' }
  },

  // Pages À propos
  {
    path: "/about",
    name: "About",
    component: AboutPage,
    meta: { requiresAuth: false }
  },
  {
    path: "/nlite",
    name: "NLite",
    component: AboutNLitePage,
    meta: { requiresAuth: false }
  },
  {
    path: "/nbusiness",
    name: "NBusiness",
    component: AboutNBusinessPage,
    meta: { requiresAuth: false }
  },
  {
    path: "/nconsulting",
    name: "NConsulting",
    component: AboutNConsultingPage,
    meta: { requiresAuth: false }
  },
  // Pages légales
  {
    path: "/terms",
    name: "Terms",
    component: TermsPage,
    meta: { requiresAuth: false }
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: PrivacyPage,
    meta: { requiresAuth: false }
  },
  {
    path: "/legal",
    name: "Legal",
    component: LegalPage,
    meta: { requiresAuth: false }
  },
  {
    path: "/nmt",
    name: "Nmt",
    component: NmtPage,
    meta: { requiresAuth: false }
  },
  {
    path: "/faq",
    name: "Faq",
    component: FaqPage,
    meta: { requiresAuth: false }
  },
  {
    path: "/contact",
    name: "Contact",
    component: ContactPage,
    meta: { requiresAuth: false }
  },
  {
    path: "/devis",
    name: "Devis",
    component: DevisPage,
    meta: { requiresAuth: false }
  },

  // Route 404
  {
    path: "/:catchAll(.*)",
    redirect: "/"
  }
]

export default routes
